<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-data-table
		:headers="headers"
		:rows-per-page-items="[10,20,25]"
		:items="projects"
		:pagination.sync="pagination"
		:total-items="itemCount"
		class="elevation-1 ma-4">
		<template v-slot:items="props">
			<td>{{ props.item.projectCode }}</td>
			<td>{{ props.item.projectName }}</td>
			<td>{{ props.item.contestName }}</td>
			<td>{{ props.item.agencyName }}</td>
			<td>{{ props.item.country }}</td>
			<td>
				<v-tooltip bottom v-if="!props.item.hideFromUser">
					<template v-slot:activator="{ on }">
						<v-btn icon v-if="roles.isAdministrator() || userDepartmentContest(props.item)"
							@click="showProjectPanel(props.item)">
							<v-icon v-on="on">
								business
							</v-icon>
						</v-btn>
					</template>
					<span>Panel projektu</span>
				</v-tooltip>
				<v-tooltip bottom v-if="agencyProjectViewAvailable(props.item) && !props.item.hideFromUser">
					<template v-slot:activator="{ on }">
						<v-btn icon
							@click="viewAgencyProject(props.item)">
							<v-icon v-on="on">
								description
							</v-icon>
						</v-btn>
					</template>
					<span>Podgląd</span>
				</v-tooltip>
				<v-tooltip bottom v-if="!props.item.hideFromUser">
					<template v-slot:activator="{ on }">
						<v-btn icon v-if="roles.isAdministrator() || userDepartmentContest(props.item)"
							@click="showProjectSummary(props.item)">
							<v-icon small v-on="on">
								ballot
							</v-icon>
						</v-btn>
					</template>
					<span>Podsumowanie projektu</span>
				</v-tooltip>
			</td>
		</template>
	</v-data-table>
</template>

<script>
	import {Api} from "../../../../../api";

	export default {
		name: "SupervisedAgencyProjectsTable",

		data () {
			return {
				headers: [
					{text: "Nr projektu", value: "projectCode", align: "left", sortable: true},
					{text: "Nazwa projektu", value: "projectName", sortable: true},
					{text: "Nazwa naboru", value: "contestName", sortable: true},
					{text: "Nazwa placówki", value: "agencyName", sortable: true},
					{text: "Kraj główny", value: "country", sortable: true},
					{text: "Akcje", value: "action", sortable: false}
				],
				projects: [],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
			};
		},

		watch: {
			"pagination": {
				handler () {
					this.getItemList();
				},
				deep: true
			},
		},

		methods: {
			buildSort () {
				let order = this.pagination.descending ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			userDepartmentContest (project) {
				return (this.roles.isLocalAdministrator() || this.roles.isDepartmentEmployee()) && project.contestFromUserDepartment;
			},

			agencyProjectViewAvailable (project) {
				return this.roles.isAdministrator() || this.userDepartmentContest(project);
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this,
					"/supervised-agency-projects/list?search=userId::" + this.$route.params.userId + '$$'
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.projects = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			viewAgencyProject (project) {
				this.$router.openInNewTab("/view/agency-contest/" + project.contestId + "/project/" + project.agencyId + "/" + project.id);
			},

			showProjectSummary (project) {
				this.$router.push("/app/agency-project/" + project.id + "/summary/");
			},

			showProjectPanel (project) {
				this.$router.push("/app/agency-contest/" + project.contestId + "/project-panel/" + project.id);
			},

			printAllCountries (project) {
				let output = project.country;
				project.extraCountries.forEach(country => output = output + ', ' + country);
				return output;
			}
		}
	};
</script>

<style scoped>

</style>
